import React, { useEffect, useContext, useState } from 'react'
import 'react-credit-cards/es/styles-compiled.css'
import FlexView from 'react-flexview/lib'
import { isInFlow } from '../../../services/utils'
import { BrowserView, MobileView } from 'react-device-detect'
import { useLocation } from 'react-router-dom'
import { BackButton } from '../../Core/Buttons/BackButton'
import { BottomSheetPolicySummary } from '../../Insurance/BottomSheetPolicySummary'
import NewFillButton from '../../Core/NewFillButton'
import { RectangleFrame } from '../../Core/Frames/RectangleFrame'
import { Grid, Checkbox, CircularProgress, FormControlLabel, Button } from '@material-ui/core'
import { SessionContextStore } from '../../../context/SessionContext'
import { GreenButton } from '../../Core/Buttons/GreenButton'
import { awaitWithLoading } from '../../../services/utils'
import { UserApi } from '../../../api/user.api'
import ErrorOutline from '@material-ui/icons/ErrorOutline'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'

const BankPayment = ({ stripe, clientSecret, onPurchase, loading, shouldCollectMandate, setShouldCollectMandate }) => {
  const location = useLocation()
  const { isBankLinked, setIsBankLinked, setClientSecret, getClientSecret } = useContext(BuyingInsuranceContextStore)
  const [collectedMandate, setCollectedMandate] = useState(false)

  const handleMandateUpdate = e => {
    const state = e.target.checked
    setCollectedMandate(state)
  }

  const handleConfirmation = async () => {
    await awaitWithLoading(confirmSetUp())
  }

  const confirmSetUp = async () => {
    const { setupIntent, error } = await stripe.confirmUsBankAccountSetup(clientSecret)
    if (error) return

    switch (setupIntent.status) {
      case 'succeeded':
        let response = await UserApi.attachPaymentMethod(setupIntent.payment_method, true, 'ACH')

        if (!response.ok) return
        setClientSecret(null)
        setShouldCollectMandate(false)
        setCollectedMandate(false)
        setIsBankLinked(false)
        await onPurchase()
        await getClientSecret()
        if (!isInFlow(location.pathname) && response.ok) {
          EventEmitterService.dispatch(EventKey.ShowSuccess, {
            title: 'Payment method changed successfully!',
            body: 'Successfully changed payment method to ACH Debit.',
          })
        }

        break
      case 'requires_payment_method':
      case 'verify_with_microdeposits':
        EventEmitterService.dispatch(EventKey.ShowWarning, {
          title: 'We were not able to process this payment request',
          body: 'Please try a different bank account or use a different payment method.',
        })
        break
    }
  }

  return (
    <>
      <Grid container item xs={12} sm={9} className="margin-top-basic margin-bottom-basic bank-container">
        <RectangleFrame
          color="purple"
          className="no-margins-sides"
        >{`If you wish to edit your bank account details, press the ACH button again.`}</RectangleFrame>
        {(shouldCollectMandate || isBankLinked) && (
          <>
            <RectangleFrame color="grey" className="no-margins-sides">
              <div className="margin-bottom-basic">
                {`By clicking [accept], you authorize VOOM to debit the bank account specified above for any amount owed for charges arising from your use of VOOM’s services and/or purchase of products from VOOM, pursuant to VOOM’s website and terms, until this authorization is revoked. You may amend or cancel this authorization at any time by providing notice to VOOM with 30 (thirty) days notice.`}
              </div>
              <div>
                {`If you use VOOM’s services or purchase additional products periodically pursuant to VOOM’s terms, you authorize VOOM to debit your bank account periodically. Payments that fall outside of the regular debits authorized above will only be debited after your authorization is obtained.`}
              </div>
            </RectangleFrame>
            <FormControlLabel
              label="I accept the terms of use."
              control={<Checkbox color="primary" checked={collectedMandate} onChange={handleMandateUpdate} name="mandate" />}
            />
          </>
        )}
        {loading && (
          <Grid container justifyContent="center" className="bank-progress-wheel">
            <CircularProgress />
          </Grid>
        )}
      </Grid>
      <BrowserView>
        {(shouldCollectMandate || isBankLinked) &&
          (!isInFlow(location.pathname) ? (
            <FlexView className="margin-top-basic" hAlignContent={'center'}>
              <NewFillButton disabled={!collectedMandate} onClick={handleConfirmation}>
                Save Changes
              </NewFillButton>
            </FlexView>
          ) : (
            <Grid container justifyContent="flex-end" item xs={12} sm={9}>
              <GreenButton container item xs={12} className="margin-bottom-basic" onClick={handleConfirmation} disabled={!collectedMandate}>
                Purchase
              </GreenButton>
            </Grid>
          ))}
      </BrowserView>
      <MobileView>
        {!isInFlow(location.pathname) && (
          <FlexView className="margin-top-basic" hAlignContent={'center'}>
            <NewFillButton disabled={!collectedMandate} onClick={handleConfirmation}>
              Save Changes
            </NewFillButton>
          </FlexView>
        )}

        {isInFlow(location.pathname) && (shouldCollectMandate || isBankLinked) && (
          <BottomSheetPolicySummary title={'Purchase'} onClick={handleConfirmation} />
        )}
      </MobileView>
    </>
  )
}

export default BankPayment
